export default __webpack_public_path__ + "static/media/TcitLogo.09580946.png";